import { render, staticRenderFns } from "./FundingAssessorRequestsIndex.vue?vue&type=template&id=3bb9010e&"
import script from "./FundingAssessorRequestsIndex.vue?vue&type=script&lang=js&"
export * from "./FundingAssessorRequestsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports